import { Box, styled } from '@mui/material'
import { unifiedColors } from 'styles/colors'
import { themeUtils } from 'styles/theme'

export const FiltersBox = styled(Box)`
  ${themeUtils.minWidth.md} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    padding-top: 4px;
    border: 2px solid ${unifiedColors.border.accent};
    border-radius: 24px;
    background-color: ${unifiedColors.surface.subdued};
    box-shadow: 2px 3px 0px 0px ${unifiedColors.shadow.accent};
    outline: none;
    z-index: 1301;
  }
  ${themeUtils.maxWidth.md} {
    display: grid;
    height: 100%;
  }
`
